import { TimeSignal } from 'graphql/types';
import { NotesGroupByStrategy } from './NotesGroupBySorter';

export const DEFAULT_GROUP_KEY = 'notes';

export class NoOpGroupByStrategy implements NotesGroupByStrategy {
  constructor() {}

  generateGroups(notes: TimeSignal[]): Record<string, TimeSignal[]> {
    return { [DEFAULT_GROUP_KEY]: notes };
  }
}
